import axios from '@/common/axios'
import API from '@/config/apis'

// 获取公告
export function getNotice(params) {

    return new Promise(function(resolve, reject){
        axios('post', API.MAIN.NOTICE, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}

// 主页标识地区
export function toAddArea(params) {

    axios('post', API.MAIN.AREA, params)
        .then(function (result) {

        })

}

// 请求首页 焦点图
export function getFocusPictures(params) {

    return new Promise(function(resolve, reject){
        axios('post', API.FOCUS.PICTURES, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}

// 请求首页 产品分类列表
export function getProductCategoryList(params) {

    return new Promise(function(resolve, reject){
        axios('post', API.PRODUCT.CATEGORY, params)
            .then(function (result) {
                resolve(result.data)
            })
    })

}

// 请求首页 新闻列表
export function getAllNews() {

    return new Promise(function(resolve, reject){
        axios('post', API.NEWS.LIST)
            .then(function (result) {
                resolve(result.data)
            })
    })

}

